import axios from "axios";

const API = "/api";

const cabecalho = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const get = (caminho, params) => axios.get(`${API}${caminho}`, { headers: cabecalho(), params }).then((r) => r.data);

// Cartões, comparações e Faturamento Diário (com os dias zerados).
export const buscarPeriodo = ({ inicio, fim }) => get("/relatorios", { data_inicio: inicio, data_fim: fim });

// Dia da semana, hora, pagamentos, módulos, top clientes e insights de combo.
export const buscarResumo = ({ inicio, fim }) => get("/resumo", { data_inicio: inicio, data_fim: fim });

// Seções detalhadas: "produtos" e "pagamentos".
export const buscarDetalhado = (tipo, { inicio, fim }) => get("/resumo/detalhado", { tipo, data_inicio: inicio, data_fim: fim });

// Relatório de Módulos: vendas, CMV, despesas e lucro por canal.
export const buscarModulos = ({ inicio, fim }) => get("/relatorios/modulos", { data_inicio: inicio, data_fim: fim });
